import React from "react";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { serviceList } from "../utils/BeadsData";
import { Card, CardContent, CardMedia, Typography, Button, Grid, Box } from "@mui/material";

const ServiceArea = () => {
  return (
    <Box sx={{ bgcolor: 'bg-relative', my: 5 }}>
      {/* <Box sx={{ pt: 8, pb: 5, px: { xs: 2, sm: 3, md: 5 }, bgcolor: 'background.default' }}> */}
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12}>
          <Box textAlign="center">
            <Typography variant="h3" component="h3" sx={{ my: 2, fontWeight: 'bold', color: 'darkOrange' }}>
              Ways To Get Invloved
            </Typography>
            <Typography paragraph sx={{ mx: 5 }}>
              In order to achieve our mission we do support sponsoring a girl, mentoring a girl,
              building schools & libraries and fostering school programs.
            </Typography>
          </Box>
        </Grid>

        {serviceList.slice(0, 5).map((data, index) => (
          <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
            <Box sx={{ maxWidth: 340, margin: '0 auto' }}>
              <Card
                sx={{
                  width: '100%',
                  height: '450px',
                  borderRadius: '1rem',
                  boxShadow: 4,
                  mb: 3,
                  transition: 'transform .3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.03)',
                  },
                }}
              >
                <CardContent>
                  <Typography variant="h5" component="div"
                    sx={{ color: '#000', fontWeight: 'bold', textAlign: 'center', my: 1 }}
                  >
                    {data.title}
                  </Typography>
                  <Typography sx={{
                    width: '100%',
                    // wordWrap: 'break-word',
                  }}
                  >
                    {data.des}
                  </Typography>
                  <Box sx={{ my: 3, px: 6, textAlign: 'center' }}>
                    <Link to='/donate'>
                      <Button
                        variant="outlined"
                        color="primary"
                        endIcon={<FaPlus style={{ fontSize: '0.8rem' }} />}
                        sx={{
                          borderRadius: '25px',
                          color: '#0d6efd',
                          border: '1.5px solid #0d6efd',
                          '&:after': {
                            background: '#0d6efd',
                          },
                          '&:hover': {
                            backgroundColor: '#f39c12',
                            color: '#fff',
                            borderColor: '#f39c12',
                            transition: 'all 0.5s ease',
                            zIndex: 0,
                          },
                          '&:focus': {
                            color: '#fff',
                          }
                        }}
                      >
                        Learn More
                      </Button>
                    </Link>
                  </Box>
                </CardContent>
                <CardMedia
                  component="img"
                  alt={data.title}
                  image={data.img}
                  sx={{
                    width: '100%',
                    // objectFit: 'cover',
                    backgroundSize: 'cover',
                    display: 'block'
                  }}
                />
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ServiceArea;
